<div class="container-fluid reset-password">
  <div class="row h-100">
    <div class="col-lg-4 offset-lg-4 py-lg-5 py-4">
      <div class="right-section">
        <div class="right-section-content">
          <ngb-alert class="auth-alert" type="danger" *ngIf="errorMessage">
            <div class="d-flex align-items-center">
              <span class="me-2">
                <img width="32" src={{invalidIcon}} alt="">
              </span>
              {{errorMessage}}
            </div>
          </ngb-alert>

          <div class="onboarding-card" [ngClass]="{ 'd-none': hideForm }">
            <div class="text-center">
              <img src={{verifiedImage}} alt="">
              <h1 class="onboarding-card-title my-3">Reset password</h1>
            </div>

            <div class="content">
              <h4 class="text-center lh-base">Enter your new password and get back to your veterinary professional community.</h4>
              <form [formGroup]="form" action="#" class="onboarding-form needs-validation" novalidate>
                <div class="mb-3 has-validation">
                  <label for="exampleInputEmail1" class="text-black font-17 pb-2 text-start">E-mail</label>

                  <input type="email" maxlength="255" formControlName="email" class="form-control"
                    [ngClass]="{ 'is-invalid': (form.get('email')?.touched && form.get('email')?.errors) }"
                    placeholder="Please enter your e-mail" id="exampleInputEmail1" aria-describedby="emailHelp" required>

                  <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('email') && !form.get('email')?.hasError('pattern') ">
                    Invalid e-mail address.
                  </div>

                  <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('required')">
                    E-mail is required
                  </div>

                  <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('pattern')">
                    Please enter a correct e-mail.
                  </div>
                </div>

                <div>
                  <div class="mb-3 has-validation">
                    <label class="text-black font-17 pb-2 text-start">Enter new password</label>
                    <div class="password-wrap">
                      <input type="{{ showPassword ? 'text' : 'password' }}" formControlName="new_password" class="form-control"
                        [ngClass]="{ 'is-invalid': (form.get('new_password')?.touched && form.get('new_password')?.errors)  }"
                        required>

                      <a class="show-password active" href="#" (click)="togglePasswordVisibility($event)">
                        {{ showPassword ? "Hide" : "Show" }}
                      </a>

                      <div class="invalid-feedback" *ngIf="form.get('new_password')?.hasError('required')">
                        Password is required
                      </div>

                      <div class="invalid-feedback" *ngIf="form.get('new_password')?.hasError('minlength')">
                        Please enter at least 8 character password.
                      </div>
                    </div>
                  </div>

                  <div class="mb-3 has-validation">
                    <label for="exampleInputPassword1" class="text-black font-17 pb-2 text-start">Confirm new password</label>
                    <div class="password-wrap">
                      <input type="{{ showConfirmPassword ? 'text' : 'password' }}" formControlName="confirm_password" class="form-control"
                        [ngClass]="{ 'is-invalid': (form.get('confirm_password')?.touched && form.get('confirm_password')?.errors)}"
                        id="exampleInputPassword1" required>

                      <a class="show-password active" href="#" (click)="toggleConfirmPasswordVisibility($event)">
                        {{ showConfirmPassword ? "Hide" : "Show" }}
                      </a>

                      <div class="invalid-feedback" *ngIf="form.get('confirm_password')?.hasError('required')">
                        Confirm new password is required
                      </div>

                      <div class="invalid-feedback" *ngIf="form.get('confirm_password')?.hasError('mismatch') &&
                        !form.get('confirm_password')?.hasError('required')">
                           Password Doesn't Match
                      </div>
                    </div>
                  </div>

                  <button *ngIf="!loader" type="submit" class="btn-outlined bg-black text-white" (click)="savePassword();
                    trackButtonClick('Save Password')">
                    <span>Save Password</span>
                  </button>
                  <spinner *ngIf="loader"></spinner>
                </div>
              </form>
            </div>
          </div>

          <div class="onboarding-card" [ngClass]="{ 'd-none': !hideForm }">
              <div class="text-center">
                <img src={{verifiedImage}} alt="">
                <h1 class="onboarding-card-title my-3">Password Changed</h1>
              </div>
              <p class="mb-4 text-center">Your password has been changed successfully. Please login with with your updated credentials.</p>
            <div class="contentju d-flex justify-content-center">
              <button class="btn-outlined bg-black text-white" routerLink="/login">Back to login</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
